export const CONVERSATION_MODE = {
    REPLY: 'reply',
    READ_ONLY: 'read_only',
    HISTORY: 'history',
    DRAFT: 'draft',
};
